// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 524 ? "2170a4aa" : chunkId) + "." + {"436":"86981b60270eece6","524":"7408d964c5df804e"}[chunkId] + ".js";
};